import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.css'
})
export class ButtonComponent {
  @Input() buttonClass: string;
  @Input() buttonId: string;
  @Input() label: string;
  @Input() icon: string;
  @Output() buttonClick: EventEmitter<any> = new EventEmitter<any>();

  click()
  {
    this.buttonClick.emit();
  }
}
